const Backbone  = window.Backbone;
const routes    = window.routes;

import SubjectCollectionModel from '../models/SubjectCollectionModel';

class SubjectCollection extends Backbone.Collection {

    get model() { return SubjectCollectionModel; }

    get url() { return window.url(routes.rest.subjects.getGroupedByParent); }
}

export default SubjectCollection;
